import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withModifiers as _withModifiers, unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "sidebar" }
const _hoisted_2 = {
  action: "#",
  method: "get"
}
const _hoisted_3 = { class: "input-group mb-3 pb-1" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-tertiary text-1 p-2"
}, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-search m-2" })
], -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-semi-bold pt-4" }, "กลุ่มชุดข้อมูล", -1)
const _hoisted_6 = { class: "nav nav-list flex-column" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-semi-bold pt-4" }, "คำสำคัญ", -1)
const _hoisted_9 = { class: "nav nav-list flex-column" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h5", { class: "font-weight-semi-bold pt-4" }, "รูปแบบ", -1)
const _hoisted_12 = { class: "nav nav-list flex-column mb-5" }
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "tabs tabs-secondary mb-4 pb-2" }
const _hoisted_15 = /*#__PURE__*/_createStaticVNode("<ul class=\"nav nav-tabs\"><li class=\"nav-item\"><a class=\"nav-link show active text-1 font-weight-bold text-uppercase\" href=\"#popularPosts\" data-bs-toggle=\"tab\">POPULAR</a></li><li class=\"nav-item\"><a class=\"nav-link text-1 font-weight-bold text-uppercase\" href=\"#recentPosts\" data-bs-toggle=\"tab\">RECENT</a></li></ul>", 1)
const _hoisted_16 = { class: "tab-content" }
const _hoisted_17 = {
  class: "tab-pane active",
  id: "popularPosts"
}
const _hoisted_18 = { class: "simple-post-list" }
const _hoisted_19 = { class: "post-info" }
const _hoisted_20 = { class: "post-meta" }
const _hoisted_21 = {
  class: "tab-pane",
  id: "recentPosts"
}
const _hoisted_22 = { class: "simple-post-list" }
const _hoisted_23 = { class: "post-info" }
const _hoisted_24 = { class: "post-meta" }

import {useCommonStore} from "@/stores/common.store";
import {onMounted} from "vue";
import useDateUtils from "@/api/composable/date-utils";


export default /*#__PURE__*/_defineComponent({
  __name: 'Sidebar',
  props: {
  groupSumms: {
    type: Array,
    default: ()=> []
  },
  tags: {
    type: Array,
    default: ()=> []
  },
  formats: {
    type: Array,
    default: ()=> []
  },
  recents: {
    type: Array,
    default: ()=> []
  },
  populars: {
    type: Array,
    default: ()=> []
  }
},
  emits: [
  'filter-click'
],
  setup(__props, { emit: emits }) {

const props = __props;



// const searchFilter = (value: string) => {
//   emits('filter-click', value)
// }



const commonStore = useCommonStore();
const dateUtils = useDateUtils();

onMounted(async () => {
  await commonStore.getDataFormatOptions();
});

return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("aside", _hoisted_1, [
    _createElementVNode("form", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("input", {
          class: "form-control text-1",
          placeholder: "ค้นหาชุดข้อมูล",
          type: "text",
          onKeyup: _cache[0] || (_cache[0] = ($event: any) => (emits('filter-click',$event.target.value,'search')))
        }, null, 32),
        _hoisted_4
      ])
    ]),
    _hoisted_5,
    _createElementVNode("ul", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.groupSumms, (groupSumm) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: groupSumm.id
        }, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#",
            onClick: _withModifiers(($event: any) => (emits('filter-click',groupSumm?.id,'group')), ["prevent"])
          }, _toDisplayString(groupSumm?.name) + " (" + _toDisplayString(groupSumm?.total) + ")", 9, _hoisted_7)
        ]))
      }), 128))
    ]),
    _hoisted_8,
    _createElementVNode("ul", _hoisted_9, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.tags, (tag) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: tag?.tagId
        }, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#",
            onClick: _withModifiers(($event: any) => (emits('filter-click',tag?.tagId.toString(),'tag')), ["prevent"])
          }, _toDisplayString(tag?.tagTitle) + " (" + _toDisplayString(tag?.total) + ")", 9, _hoisted_10)
        ]))
      }), 128))
    ]),
    _hoisted_11,
    _createElementVNode("ul", _hoisted_12, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.formats, (format) => {
        return (_openBlock(), _createElementBlock("li", {
          class: "nav-item",
          key: format?.dataFormat
        }, [
          _createElementVNode("a", {
            class: "nav-link",
            href: "#",
            onClick: _withModifiers(($event: any) => (_ctx.$emit('filter-click',format?.dataFormat,'format')), ["prevent"])
          }, _toDisplayString(_unref(commonStore).dataFormatName(format?.dataFormat, null)) + " (" + _toDisplayString(format?.total) + ") ", 9, _hoisted_13)
        ]))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_14, [
      _hoisted_15,
      _createElementVNode("div", _hoisted_16, [
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("ul", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.populars, (popular) => {
              return (_openBlock(), _createElementBlock("li", {
                key: popular?.id
              }, [
                _createElementVNode("div", _hoisted_19, [
                  _createVNode(_component_router_link, {
                    to: `/opendata/${popular?.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(popular?.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_20, _toDisplayString(_unref(dateUtils).toDateThai(popular?.createdDate)), 1)
                ])
              ]))
            }), 128))
          ])
        ]),
        _createElementVNode("div", _hoisted_21, [
          _createElementVNode("ul", _hoisted_22, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.recents, (recent) => {
              return (_openBlock(), _createElementBlock("li", {
                key: recent?.id
              }, [
                _createElementVNode("div", _hoisted_23, [
                  _createVNode(_component_router_link, {
                    to: `/opendata/${recent?.id}`
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(recent?.title), 1)
                    ]),
                    _: 2
                  }, 1032, ["to"]),
                  _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(dateUtils).toDateThai(recent?.createdDate)), 1)
                ])
              ]))
            }), 128))
          ])
        ])
      ])
    ])
  ]))
}
}

})